import axios from 'axios';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import DefaultLoader from '../../../components/loader/DefaultLoader';
import BatterTable from '../../../components/table/BatterTable';
import { flatObject } from '../../../utils/flat';
import {useCookies} from 'react-cookie';
import TableWrapper from '../../../components/table/TableWrapper';
import dateSetting from '../../../utils/dateSetting';

function TotalBatterRecord({profile}) {
    const [cookies] = useCookies(['hiball_token']);
    let [loading, setLoading] = useState(false);
    let [seasonRecord, setSeasonRecord] = useState({});
    let {playerId, birthdate} = profile;
    
    useEffect(() => {
        let dateObj = dateSetting();
        
        let basicRecord = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'digestBattingRecord', recordName: 'seasonRecord',
                batterIds: playerId,
                seasons: [dateObj['season']-2, dateObj['season']-1, dateObj['season']].toString(),
                groupingColumn: 'season',
                gameTypeCode: 4201,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        });

        let trackmanRecord = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: {
                recordType: 'digestBattingRecord', recordName: 'selectTrackManRecord',
                batterIds: playerId,
                seasons: [dateObj['season']-2, dateObj['season']-1, dateObj['season']].toString(),
                groupingColumn: 'season',
                gameTypeCode: 4201,
                authToken:JSON.stringify(cookies['hiball_token'])
            }
        });

        Promise.all([
            basicRecord, trackmanRecord
        ]).then((result) => {
            
            let trackmanFlatRecord = _.map(result[1]['data']['result'], (item) => {
                item['type'] = item['season']+"_"+item['batterId'];
                return flatObject(item);
            });

            let indexedTrackmanData = _.keyBy(trackmanFlatRecord, (item) => item['season']);

            let basicFlatRecord = _.map(result[0]['data']['result'], (item) => {
                let season = item['season'];
                let birthdateYear = birthdate && birthdate.split('/');
                let age = (season*1-birthdateYear[0]*1)-1;

                let trackmanSeasonData = indexedTrackmanData[season];
                item['hardHitRate'] = trackmanSeasonData['hardHitRate'];
                item['barrelRate'] = trackmanSeasonData['barrelRate'];
                item['vaildHitRate'] = trackmanSeasonData['vaildHitRate'];
                item['type'] = item['season']+"_"+item['batter']['batterId'];
                item['age'] = age;
                return flatObject(item);
            });

            setSeasonRecord({
                seasonRecord: basicFlatRecord,
                trackmanRecord: trackmanFlatRecord
            });
            setLoading(true);
        })
    }, []);

    if(!loading) {
        return <div style={{height: '300px'}}><DefaultLoader /></div>
    }

    return (
        <>
        <TableWrapper title={'overall'} id={'batter_total'} trackmanYn={true}>
            <BatterTable data={seasonRecord['seasonRecord']} column={'total'}/>
        </TableWrapper>
        <TableWrapper title={'plateDisciplines'} id={'batter_contact'}>
            <BatterTable data={seasonRecord['trackmanRecord']} column={'contact'}/>
        </TableWrapper>
        <TableWrapper title={'battedBallQuality'} id={'batter_power'}>
            <BatterTable data={seasonRecord['trackmanRecord']} column={'power'}/>
        </TableWrapper>
        <TableWrapper title={'battedBallType'} id={'batter_hittingType'}>
            <BatterTable data={seasonRecord['trackmanRecord']} column={'hittingType'}/>
        </TableWrapper>
        </>
    )
}

export default TotalBatterRecord;